import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSearchSessionGuid', function (searchSessionGuid) {
    getStore().searchSessionGuid = searchSessionGuid;
});
//# sourceMappingURL=setSearchSessionGuid.js.map